import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  ChartBar, MagnifyingGlass, TrendDown, Sparkle, UsersThree, Kanban,
  Bell, Gear, SignOut, Broadcast, Buildings, Warning, Rocket
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Dashboard", icon: ChartBar, testid: "nav-dashboard" },
  { to: "/apps", label: "Apps", icon: MagnifyingGlass, testid: "nav-apps" },
  { to: "/fresh", label: "Fresh Launches", icon: Rocket, testid: "nav-fresh" },
  { to: "/low-rated", label: "Low Rated", icon: Warning, testid: "nav-low-rated" },
  { to: "/rating-drops", label: "Rating Drops", icon: TrendDown, testid: "nav-rating-drops" },
  { to: "/opportunities", label: "Opportunities", icon: Sparkle, testid: "nav-opportunities" },
  { to: "/developers", label: "Developers", icon: Buildings, testid: "nav-developers" },
  { to: "/leads", label: "Leads", icon: Kanban, testid: "nav-leads" },
  { to: "/alerts", label: "Alerts", icon: Bell, testid: "nav-alerts" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = user?.role === "admin";

  return (
    <aside className="w-60 border-r border-border bg-secondary/30 noise flex flex-col shrink-0" data-testid="sidebar">
      <div className="px-5 py-6 border-b border-border">
        <div className="flex items-center gap-2">
          <Broadcast size={22} weight="bold" className="text-primary" />
          <div>
            <div className="font-heading font-black text-lg leading-none">AppRadar</div>
            <div className="overline-label text-muted-foreground mt-1">Play Store Intel</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 py-4 px-2 space-y-0.5">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === "/"}
            data-testid={n.testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors duration-150
              ${isActive
                ? "bg-primary text-primary-foreground"
                : "text-foreground/80 hover:bg-accent hover:text-foreground"}`
            }
          >
            <n.icon size={16} weight="regular" />
            {n.label}
          </NavLink>
        ))}
        {isAdmin && (
          <NavLink to="/admin" data-testid="nav-admin"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium mt-4
              ${isActive ? "bg-primary text-primary-foreground" : "text-foreground/80 hover:bg-accent"}`}>
            <Gear size={16} /> Admin
          </NavLink>
        )}
      </nav>
      <div className="border-t border-border p-3">
        <div className="flex items-center gap-2 px-2 py-2">
          <div className="w-8 h-8 rounded-sm bg-primary/10 text-primary flex items-center justify-center font-bold text-xs">
            {user?.email?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium truncate">{user?.name || user?.email}</div>
            <div className="text-[10px] overline-label text-muted-foreground">{user?.role}</div>
          </div>
          <button data-testid="btn-logout" onClick={async () => { await logout(); nav("/login"); }}
                  className="p-2 hover:bg-accent rounded-sm" title="Logout">
            <SignOut size={16} />
          </button>
        </div>
      </div>
    </aside>
  );
}
